import type { InstructionAction } from "../schemas/instruction";
import type { Address } from "../schemas/misc";

import { keccak256, toHex } from "viem";

import { instructionAbiMap } from "@generated/instruction-abi";

// creates eip-712 domain for otim delegate contract
export function createOtimDelegateDomain(
  delegateAddress: Address,
  chainId: number,
) {
  return {
    chainId,
    name: "OtimDelegate",
    salt: keccak256(toHex("ON_TIME_INSTRUCTED_MONEY")),
    verifyingContract: delegateAddress,
    version: "1",
  };
}

// creates eip-712 types for instruction activation
export function createInstructionActivationTypes(
  actionType: InstructionAction,
): (typeof instructionAbiMap)[InstructionAction]["types"] {
  return instructionAbiMap[actionType].types;
}
